import { Icon } from "@/react/components/shared/Icon";
import { Button } from "@/react/components/shared/uikit/Button";

interface AddButtonProps {
  dataTestId?: string;
  disabled?: boolean;
  label: string;
  onClick: () => void;
}

export const AddButton = ({
  onClick,
  disabled,
  label,
  dataTestId,
}: AddButtonProps) => (
  <div className="pl-6">
    <Button
      disabled={disabled}
      type="button"
      onClick={onClick}
      variant="circle"
      data-testid={dataTestId}
    >
      <Icon type="20-plus-v2" />
      {label}
    </Button>
  </div>
);
